module.exports = __webpack_public_path__ + "static/media/SaoPaulo_kmeans_202_400.143eff27.csv";